import { getCurrentLocale } from '@/utils/i18n';

export abstract class ObjectMapper {
    static getTranslatedName(labelList: Label[] | undefined): string | undefined {
        if (!labelList) {
            console.error('Property labelList is missing or undefined');
            return;
        }

        const currentLocale: string = getCurrentLocale().toUpperCase();

        // Vérifier que labelList est bien un array
        if (!Array.isArray(labelList)) {
            console.warn('labelList is not an array:', labelList);
            return name || '';
        }

        const label: Label | undefined = labelList.find((label: any) => {
            return label.langValue === currentLocale;
        });

        return label?.label;
    }
}
